#import "./factFinderNgFacetFragment.gql"

query getDocumentListNg(
  $factFinderChannel: FactFinderChannel!
  $baseSiteId: CatalogChannel!
  $language: CatalogLocale!
  $page: Int
  $quantity: Int
  $query: String
  $filters: [FactFinderGroupElementInput]
  $supplier: String
) {
  getDocumentListNg(
    factFinderChannel: $factFinderChannel
    baseSiteId: $baseSiteId
    language: $language
    page: $page
    quantity: $quantity
    query: $query
    filters: $filters
    supplier: $supplier
  ) {
    resultStatus
    resultCount
    currentPage
    pageCount
    nextLink
    facets {
      ...factFinderNgFacetFragment
    }
    facetDataUnselected {
      ...factFinderNgFacetFragment
    }
    documents {
      DocumentId
      Name
      Description
      Url
      Language
      Format
      FileSize
      ValidFrom
      ValidTo
      TextList {
        Key
        Value
      }
      AttributeList {
        Key
        Value
      }
      CategoryIds
      categories(channel: $baseSiteId, language: $language) {
        name
        Slug
      }
    }
  }
}
